import { gql } from "@apollo/client"

export const INCOMING_TRIPS_QUERY = gql`
  query GetIncomingTrips(
    $sort: String!
    $limit: Int
    $offset: Int
    $where: JSON
  ) {
    trips(sort: $sort, limit: $limit, start: $offset, where: $where) {
      title
      location
      from
      to
      slug
      image {
        url
      }
    }
  }
`

export type INCOMING_TRIPS_QUERY_TYPE_ITEM = {
  title: string
  location: string
  from: string
  to: string
  slug: string
  image?: {
    url: string
  }
}

export type INCOMING_TRIPS_QUERY_TYPE = {
  trips: INCOMING_TRIPS_QUERY_TYPE_ITEM[]
}
